import React from "react";

// Inline sprite rather than separate <svg> per item: the alerts list repeats the
// same handful of marks up to 20 times a page. Rendered once, hidden, and
// referenced by <use href="#icon-..."> throughout the page.
const NotificationIcons = () => (
  <svg
    width="0"
    height="0"
    style={{ position: "absolute" }}
    aria-hidden="true"
    focusable="false"
  >
    <defs>
      <symbol id="icon-bell" viewBox="0 0 24 24">
        <path
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M18 16v-5a6 6 0 0 0-12 0v5l-2 2v1h16v-1l-2-2z"
        />
        <path
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          d="M10 21a2 2 0 0 0 4 0"
        />
      </symbol>

      {/* Stands in when a reply has no face to show -- the commenter's account
          or the like itself has since been deleted. Beats initials taken from
          the notification's own title, which spell out nonsense like "IC". */}
      <symbol id="icon-reply" viewBox="0 0 24 24">
        <path
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M21 12a8 8 0 0 1-8 8H7l-4 3v-4.6A8 8 0 0 1 5 5.6 8 8 0 0 1 13 4a8 8 0 0 1 8 8z"
        />
      </symbol>

      <symbol id="icon-shield" viewBox="0 0 16 16">
        <path
          fill="none"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinejoin="round"
          d="M8 2 L13 4 V8 c 0 3 -2 5 -5 6 c -3 -1 -5 -3 -5 -6 V 4 Z"
        />
        <path
          d="M6 8 L7.5 9.5 L10 7"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>

      <symbol id="icon-cert" viewBox="0 0 32 32">
        <rect
          x="4"
          y="6"
          width="22"
          height="16"
          rx="1.5"
          fill="#F5F0E1"
          stroke="#2E2437"
          strokeWidth="1.5"
        />
        <line x1="8" y1="11" x2="22" y2="11" stroke="#2E2437" strokeWidth="1.2" />
        <line x1="8" y1="14.5" x2="18" y2="14.5" stroke="#2E2437" strokeWidth="1.2" />
        <line x1="8" y1="18" x2="16" y2="18" stroke="#2E2437" strokeWidth="1.2" />
        <circle cx="23.5" cy="18.5" r="3.5" fill="#F5B041" stroke="#2E2437" strokeWidth="1.2" />
        <path
          d="M22 21 L20.5 27 L23.5 25.2 L26.5 27 L25 21"
          fill="#FF645E"
          stroke="#2E2437"
          strokeWidth="1.2"
          strokeLinejoin="round"
        />
      </symbol>

      <symbol id="icon-badge" viewBox="0 0 32 32">
        <path
          fill="#FFA5BC"
          stroke="#2E2437"
          strokeWidth="1.5"
          strokeLinejoin="round"
          d="M11 16 L8 28 L13 25 L16 27 L19 25 L24 28 L21 16 Z"
        />
        <circle cx="16" cy="12" r="8" fill="#F5B041" stroke="#2E2437" strokeWidth="1.5" />
        <circle cx="16" cy="12" r="4.5" fill="#F3EC7A" stroke="#2E2437" strokeWidth="1.2" />
        <path fill="#C4841D" d="M16 8 L17 11 L20 11 L17.5 13 L18.5 16 L16 14 L13.5 16 L14.5 13 L12 11 L15 11 Z" />
      </symbol>

      <symbol id="icon-bulb" viewBox="0 0 32 32">
        <path
          fill="#F3EC7A"
          stroke="#2E2437"
          strokeWidth="1.5"
          strokeLinejoin="round"
          d="M16 4 a8 8 0 0 0 -5 14.5 V22 h10 V18.5 A 8 8 0 0 0 16 4 Z"
        />
        <line x1="13" y1="22" x2="19" y2="22" stroke="#2E2437" strokeWidth="1.5" />
        <rect x="13" y="23.5" width="6" height="2" rx="1" fill="#2E2437" />
      </symbol>

      {/* The 42courses blob mark, same paths as the nav logo. Stands in as the
          sender's face on anything the system itself sent -- course welcomes,
          feature announcements -- where there is no person to show. */}
      <symbol id="icon-blob" viewBox="0 0 200 200">
        <path
          fill="#2E2437"
          d="M192.43,117.14c11.53-46.12-30-39.2-53-53s-17.5-33.22-57.65-36.89S14.78,47.91,8,82.55s.25,82.91,53,94.55S180.9,163.26,192.43,117.14Z"
        />
        <path
          fill="#2E2437"
          d="M149.36,21.44c-6.46,4.67-18.7,21.13-8.53,30.51s27.73,6.23,35.8-8.82c7.22-13.44-2.11-20.87-8.75-23.83S153.07,18.82,149.36,21.44Z"
        />
        <path
          fill="#fff"
          d="M70.59,137.36H84.13v-9.25h7.62V116.46H84.13V78.51h-11l-26.3,41.12v8.48H70.59Zm-9-20.13,10.11-16.79v16.79Z"
        />
        <path
          fill="#fff"
          d="M115.8,124.85v-.17l9.16-9.51c7.8-8.13,9.51-13.19,9.51-19.87,0-11-8.91-17.56-19-17.56s-16.53,5.05-20,11.13L105.26,96c2.57-3.77,5.57-5.48,9.08-5.48a6.08,6.08,0,0,1,6.17,6.34c0,4.2-2.66,7.88-7.28,12.77l-17.4,18.76.18,9h39.06V124.85Z"
        />
      </symbol>

      <symbol id="icon-chevron-l" viewBox="0 0 16 16">
        <path
          fill="none"
          stroke="currentColor"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M10 3 L5 8 L10 13"
        />
      </symbol>

      <symbol id="icon-chevron-r" viewBox="0 0 16 16">
        <path
          fill="none"
          stroke="currentColor"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M6 3 L11 8 L6 13"
        />
      </symbol>
    </defs>
  </svg>
);

export default NotificationIcons;
